import styled from "styled-components";
import { InfoIcon } from "../../assets/icons/Cards/InfoIcon";
import { T } from "../Theme";

export const CarouselStyled = styled.div`
  width: 100%;

  .header {
    margin-top: 20px;
  }

  .headerSkeleton {
    margin: 40px 30px 0 30px;
  }

  .buttonContainer {
    max-width: 200px;
    margin: 15px auto 30px auto;
  }

  @media (min-width: 640px) {
    .header {
      margin: 0 30px;
    }
  }
`;

export const InfoIconStyled = styled.div`
  position: absolute;
  right: 15px;
  top: 20px;
  cursor: pointer;

  @media (min-width: 640px) {
    display: none;
  }
`;

export const PrimaryCard = styled.div`
  position: relative;
  max-width: 260px;
  width: 100%;
  margin: auto;
  border: 1px solid #d8d8d8;
  border-radius: 12px;
  padding: 20px 10px 20px 20px;

  & > ul {
    list-style: none;
    margin-top: 2px;

    li {
      display: grid;
      grid-template-columns: 30px 1fr;
      grid-gap: 10px;
      align-items: center;
      margin: 8px 0;

      p {
        font-size: 14px;
      }

      .icon {
        margin-right: 5px;
        background-color: #FFFFFF;
        border-radius: 50%;
        border: 1px solid ${T.blue};
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  & > .internet {
    font-size: 20px;
    font-weight: 600;
  }

  & > .megas {
    font-weight: 600;
    font-size: 24px;
  }

  & > .oferta {
    margin-top: 18px;
    font-weight: 500;
    font-size: 18px;
  }

  & > .precio {
    font-weight: 500;
    color: ${T.blue};
    margin-top: 6px;
    display: flex;
    align-items: flex-end;
  }

  & > .precio > .number {
    font-size: 24px;
  }

  & > .precio > .iva {
    font-size: 16px;
  }

  & > .doce_meses {
    font-size: 14px;
    margin-top: 2px;
  }
`;

export const CardStyled = styled.div`
  margin: 0 20px 20px 20px;
  border-radius: 12px;
  padding: 15px;
  /* max-height: 445px; */

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin: 20px 50px;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.2);
  }
`;

export const CardContent = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  .match {
    padding-top: 4px;
    background: ${T.green};
    border-radius: 8px;
    font-size: 22px;
    color: #000000;
    font-weight: bold;
    text-align: center;
    width: 170px;
    height: 36px;
    margin: 10px auto;
  }

  .iconSvg {
    padding-top: 7.5px;
    padding-right: 5px;
  }

  .con-internet {
    font-weight: 600;
    font-size: 16px;
    margin: 10px 0;
  }

  .description2 {
    display: none;
  }

  .description2 > ul {
    padding-left: 4px;
    margin: 15px 0 20px 0;

    li {
      font-size: 14px;
      margin: 8px 0;
    }
  }

  .buttonContainer {
    margin-top: 20px;
    padding-top: 20px;
    max-width: 180px;
    width: 100%;
  }

  @media (min-width: 640px) {
    display: block;
    .match {
      border-radius: 8px;
      margin: 10px 0;
    }

    .description2 {
      display: block;
    }

    .buttonContainer {
      margin-top: 0;
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 330px;
`;

export const FooterContainer = styled.div`
  width: 100%;
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
  height: auto;
  grid-column-start: 1;
  grid-column-end: -1;

  .footerContent {
    display: grid;
    grid-template-columns: 30px 1fr;
    grid-gap: 10px;
    padding: 0px 30px 20px 10px;
  }
`;
